import React from 'react';

export const LoadingAnimation = () => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full fixed inset-0 bg-white/80 backdrop-blur-sm z-50 pointer-events-none">
      <div className="flex space-x-2">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className="w-3 h-3 rounded-full bg-gradient-to-r from-[hsl(var(--color-1))] to-[hsl(var(--color-3))] animate-pulse"
            style={{
              animationDelay: `${index * 0.15}s`,
              animationDuration: '1s'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoadingAnimation;